<template>
  <v-list color="kbWhite"
          class="transparent py-0"
          width="100%"
          three-line>
    <template v-for="(call, index) in calls">
      <v-list-item :key="index" class="kbLight elevation-3 my-2" style="border-radius: 10px!important;">
        <v-list-item-action class="align-self-center">
          <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <v-icon :color="callConfigBasedOnStatus(call.lastEvent).icon.color"
                      size="30px"
                      v-on="on">
                {{ callConfigBasedOnStatus(call.lastEvent).icon.name }}
              </v-icon>
            </template>
            <span>{{ callConfigBasedOnStatus(call.lastEvent).status }}</span>
          </v-tooltip>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="kbDarkBlueText--text pb-2">
            {{ callConfigBasedOnStatus(call.lastEvent).status }}
          </v-list-item-title>
          <v-list-item-subtitle class="kbGreen--text pb-2" v-if="typeOfUser === 'record'">
            {{ $t('general.adminWhoMadeTheCall') }}: {{ call.userName || $t('general.withoutName') }}
          </v-list-item-subtitle>
          <v-list-item-subtitle class="kbGreen--text pb-2" v-else-if="typeOfUser === 'admin'">
            {{ $t('general.personName') }}: {{ call.recordName || $t('general.withoutName') }}
          </v-list-item-subtitle>
          <v-list-item-subtitle>
            {{ call.createdAt | moment('DD/MM/YYYY hh:mm a') }} -
            {{ `${$t('general.duration')}: ${call.duration} ${$t('general.minutes')}` }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
export default {
  methods: {
    callConfigBasedOnStatus (callStatus) {
      switch (callStatus) {
        case 'call_answered':
          return { icon: { name: 'mdi-phone', color: 'kbBlue' }, status: this.$t('general.callAnswered') }
        case 'call_busy':
          return { icon: { name: 'mdi-phone-alert', color: 'kbOrange' }, status: this.$t('general.callBusy') }
        case 'call_completed':
          return { icon: { name: 'mdi-phone-check', color: 'kbGreen' }, status: this.$t('general.callCompleted') }
        case 'call_missed':
          return { icon: { name: 'mdi-phone-missed', color: 'kbRed' }, status: this.$t('general.callMissed') }
        case 'call_ringing':
          return { icon: { name: 'mdi-phone-ring', color: 'kbGold' }, status: this.$t('general.callRinging') }
        case 'voicemail_missed':
          return { icon: { name: 'mdi-volume-off', color: 'kbRed' }, status: this.$t('general.voiceMailMissed') }
        default:
          return { icon: { name: 'mdi-phone-cancel', color: 'kbOrange' }, status: this.$t('withoutStatus') }
      }
    }
  },
  props: {
    calls: {
      type: Array,
      default: () => []
    },
    typeOfUser: {
      required: false,
      type: String,
      default: 'record',
      validator (value) {
        return ['record', 'admin'].indexOf(value) !== -1
      }
    }
  }
}
</script>
